import React from "react";

/**
 * Section heading with a leading "C" dot section marker
 * and a staggered Kuunari fade-up animation on words.
 */
export const SectionHeading = ({
  eyebrow,
  text = "",
  color = "var(--track)",
  eyebrowColor = "var(--calypso)",
  size = "lg",
  dot = true,
  className = "",
  testId = "section-heading",
}) => {
  const words = String(text).split(" ");
  const sizeCls = {
    sm: "text-3xl md:text-5xl",
    md: "text-4xl md:text-6xl",
    lg: "text-5xl md:text-7xl lg:text-8xl",
    xl: "text-6xl md:text-8xl lg:text-9xl",
  }[size];

  return (
    <div className={className} data-testid={testId}>
      {eyebrow && (
        <div
          className="inline-flex items-center gap-2 mb-4 font-semibold uppercase text-xs md:text-sm"
          style={{ color: eyebrowColor }}
        >
          {dot && <span className="dot-marker" aria-hidden="true" />}
          <span>{eyebrow}</span>
        </div>
      )}
      <h2
        className="kuunari-italic"
        style={{ color, fontSize: undefined }}
      >
        <span className={`block ${sizeCls}`} style={{ lineHeight: 0.92 }}>
          {words.map((w, i) => (
            <span
              key={i}
              className="inline-block mr-[0.25em] animate-fade-up"
              style={{ animationDelay: `${i * 60}ms` }}
            >
              {w}
            </span>
          ))}
        </span>
      </h2>
    </div>
  );
};

export default SectionHeading;
